// $FlowFixMe
/* eslint-disable flowtype/no-types-missing-file-annotation */

import { fromPairs } from './misc';

export const getUrlParamsString = (): string => new URLSearchParams(window.location.search)
  .toString();

export const getUrlParamsObj = (): { [string]: string } => {
  const params = new URLSearchParams(window.location.search);
  return fromPairs(params);
};

export const getUrlParam = (
  key: string,
): string | null => new URLSearchParams(window.location.search).get(key);

export const copyUrlParams = (url: string): string => {
  const params = getUrlParamsString();
  return params ? `${url}?${getUrlParamsString()}` : url;
};
